import { HTTPClient } from "../common/HTTPClient";

import { PaginationRequestParams } from "@/common/mixins/pagination";

export enum ErrorTrackingStatus {
  WAIT = "wait",
  FIXING = "fixing",
  FIXED = "fixed"
}

export interface ApplyPromotionErrorTrackingsPaginationRequestParams
  extends PaginationRequestParams {
  status: ErrorTrackingStatus | undefined;
}

export interface IncorrectInventoryErrorTrackingsPaginationRequestParams
  extends PaginationRequestParams {
  status: ErrorTrackingStatus | undefined;
}

export class ErrorTrackingClient {
  constructor(private httpClient: HTTPClient) {}

  public async findAllApplyPromotionErrorTrackings(
    params: ApplyPromotionErrorTrackingsPaginationRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/apply-promotion-error-trackings",
      method: "GET",
      params
    });

    return data;
  }

  public async resolveApplyPromotionErrorTracking(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/apply-promotion-error-trackings/${id}/resolve`,
      method: "POST"
    });

    return data;
  }

  public async findAllIncorrectInventoryErrorTrackings(
    params: IncorrectInventoryErrorTrackingsPaginationRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/incorrect-inventory-error-trackings",
      method: "GET",
      params
    });

    return data;
  }

  public async getIncorrectInventoryById(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/incorrect-inventory-error-trackings/${id}`,
      method: "GET"
    });

    return data;
  }
}
